// eslint-disable-next-line import/no-anonymous-default-export
export default {
  loading: false,
  error: false,
  getSalesReportStatus: {
    data: null,
  },
  getServiceRequestReportStatus: {
    data: null,
  },
  getSubscriptionReportStatus: {
    data: null,
  },
  getTicketReportStatus: {
    data: null,
  },
  getBusinessActivitiesStatus: {
    data: null,
  },
  getCompanyTypesReportStatus: {
    data: null,
  },
  getCompaniesReportStatus: {
    loading: false,
    data: null,
  },
};
